import { Environment, getEnvironmentConfig as getSharedConfig, EnvironmentConfig } from '@byte-store-control/config';

const environment: Environment =
  (import.meta.env.VITE_BUILD_ENV as Environment) || ('local' as Environment);

export const currentEnvironment = environment;

// Override API_BASE_URL only for local development.
//
// In deployed environments, we always route backend traffic through CloudFront at "/api"
// to avoid accidentally pointing the UI at a direct API Gateway endpoint.
const baseConfig = getSharedConfig(environment);
if (environment === 'local' && import.meta.env.VITE_API_BASE_URL) {
  baseConfig.API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
}

export const environmentConfig = baseConfig;